import React, { useState } from 'react';
import {
  AppliedFilters,
  DataTable,
  FilterSearch,
  MainLayout,
} from '../../../../../../ui';
import { data } from './Constants/data';
import { CreateNewQuestion, SelectQuestions } from './Containers';
import { getColumns, getFilterLabels } from './Functions';

import { useQuestions } from './Hooks';

export const Questions = () => {
  const {
    handleSearch,
    handleApplyFilters,
    handleRemoveFilter,
    handleClearFilters,
    appliedFilters,
  } = useQuestions();
  const [isCreateNewDrawerOpen, setIsCreateNewDrawerOpen] = useState(false);
  const [isSelectQuestionDrawerOpen, setIsSelectQuestionDrawerOpen] =
    useState(false);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const isChecked = e.target.checked;
    setSelectedRows((prevSelectedRows) => {
      if (isChecked) {
        return [...prevSelectedRows, index];
      } else {
        return prevSelectedRows.filter((rowIndex) => rowIndex !== index);
      }
    });
  };
  return (
    <>
      <MainLayout>
        <div className='wrapper flex flex-col gap-5 '>
          <div className='flex justify-between'>
            <FilterSearch
                filterOptions={getFilterLabels()}
                onSearch={handleSearch}
                onApplyFilters={handleApplyFilters}
            />
            { /* <div className="flex gap-2">
              <Button
                label="Select Question(s)"
                onClick={() => setIsSelectQuestionDrawerOpen(true)}
                variant="secondary"
                hasIcon
                icon={<AddCircleIcons />}
              />
              <Button
                label="Create New"
                onClick={() => setIsCreateNewDrawerOpen(true)}
                variant="primary"
              />
            </div> */ }
          </div>
          { appliedFilters.lenght > 0 && (
            <AppliedFilters
                appliedFilters={appliedFilters}
                handleClearFilters={handleClearFilters}
                handleRemoveFilter={handleRemoveFilter}
            />
          ) }

          <div className='relative w-full h-full overflow-x-auto'>
            <DataTable
                columns={getColumns()} // Pass the checkbox handler here
                data={data}
                rowsPerPage={10}
                currentPage={0}
                onPageChange={() => {}}
                totalPages={0}
                hasCheckBox
                hidePagination
                totalRecords={data.length}
            />
          </div>
        </div>
      </MainLayout>
      <CreateNewQuestion
          isOpen={isCreateNewDrawerOpen}
          onCloseDrawer={() => setIsCreateNewDrawerOpen(false)}
      />
      <SelectQuestions
          isOpen={isSelectQuestionDrawerOpen}
          onCloseDrawer={() => setIsSelectQuestionDrawerOpen(false)}
      />
    </>
  );
};
